export default "__VITE_ASSET__Dl4QoUYM__"